export const DRAG_START_EVENT = 'drag-start';
export const DRAG_END_EVENT = 'drag-end';
export const WINDOW_DRAG_START_EVENT = 'window-drag-start';
export const WINDOW_DRAG_END_EVENT = 'window-drag-end';

export const DRAG_EVENTS = [DRAG_START_EVENT, DRAG_END_EVENT];

export const PREVIEW_ELEMENT_TYPE = 'uploader-element-preview';
export const LOADING_ELEMENT_TYPE = 'uploader-element-loading';
export const DROPZONE_ELEMENT_TYPE = 'uploader-element-dropzone';

export const UPLOADER_ELEMENT_TYPES = [
    PREVIEW_ELEMENT_TYPE,
    LOADING_ELEMENT_TYPE,
    DROPZONE_ELEMENT_TYPE,
];
